<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">Chirurgies d'hospitalisations terminées</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableSurgeryArchive"
          identifier="B122TableSurgeryArchive"
          init-b122-table-url="/surgeryArchive/initB122Table"
          get-b122-table-results-url="/surgeryArchive/getB122TableResults"
          :fields="tableFields"
          initial-sort-by="startDate"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <surgery-delete-modal :selected="ui.selectedSurgery" @didDeleteSurgery="didDeleteSurgery()"></surgery-delete-modal>
  </div>

</template>

<script>

import B122Table from "../../components/b122/B122Table";
import SurgeryDeleteModal from "../surgery/SurgeryDeleteModal";

export default {

  name: 'SurgeryArchiveIndex',

  components: {
    B122Table,
    SurgeryDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: "Date",
          key: "startDate",
          sortable: true,
          formatter: function (value, key, item) {
            return new Date(value).toLocaleDateString('fr-FR');
          }
        },
        {
          label: "Nom",
          key: "name",
          sortable: true
        },
        {
          label: "Animal",
          key: "hospitalization.animal.name",
          sortable: true
        },
        {
          label: "Propriétaire",
          key: "hospitalization.animal.user.name",
          sortKey: "hospitalization.animal.user.lastName",
          sortable: true
        },
        {
          label: "",
          key: "actions"
        }
      ],

      ui: {
        selectedSurgery: null
      }

    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'SurgeryShow',
        params: {
          surgeryId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'SurgeryEdit',
        params: {
          surgeryId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedSurgery = row.item
      this.$bvModal.show('surgery-delete-modal')
    },

    didDeleteSurgery() {
      this.ui.selectedSurgery = null;
      this.$refs.B122TableSurgeryArchive.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/surgeryArchive/SurgeryArchiveIndex.vue